import {createRouter, createWebHashHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CategoryPage from "@/views/CategoryPage";
import CategoryProducts from "@/views/CategoryProducts";
import LoginPage from "@/views/LoginPage";
import store from '@/store'
import QRScannerPage from "@/views/QRScannerPage";
import ProfilePage from "@/views/User/ProfilePage";
import ServiceRequest from "@/views/User/ServiceRequest";
import OrderPage from "@/views/User/OrderPage";
import OrderDetail from "@/views/User/OrderDetail";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomeView
    },
    {
        path: '/category/:type',
        name: 'Category',
        component: CategoryPage
    },
    {
        path: '/category/:type/:id',
        name: 'CategoryProducts',
        component: CategoryProducts
    },
    {
        path: '/profile',
        name: 'Profile',
        component: HomeView
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginPage
    },
    {
        path: '/qr',
        name: 'QR',
        component: QRScannerPage
    },
    {
        path: '/profile',
        name: 'Profile',
        component: ProfilePage
    },
    {
        path: '/profile/service-request',
        name: 'ServiceRequest',
        component: ServiceRequest
    },
    {
        path: '/profile/orders',
        name: 'Orders',
        component: OrderPage
    },
    {
        path: '/profile/orders/:id',
        name: 'OrderDetail',
        component: OrderDetail
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    linkActiveClass: '',
    linkExactActiveClass: '',
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.name === 'Login')) {
        next()
    } else {
        if (store.getters.isLoggedIn) {
            next()
        } else {
            next({path: '/login'})
        }
    }
})

export default router
